import {Pipe, PipeTransform} from '@angular/core';
import {MachineStore}        from '../../../stores/docu/machine.store';
import {TranslationStore}    from '../../../stores/translation/translation.store';

@Pipe({
  name: 'getMachineKindName'
})
export class GetMachineKindNamePipe implements PipeTransform {

  constructor(private machineStore: MachineStore,
              private translationStore: TranslationStore) {
  }

  transform(kindId: number): string {
    const machineType = this.machineStore.Listen(s => s.machineTypes).getValue().FirstOrDefault(i => i.Id === kindId);
    if (machineType) {
      return this.translationStore.FindTranslationForSelectedLanguage(machineType.Description);
    } else {
      return null;
    }
  }

}
